import React from 'react';

function SlideThumbnailRow(props) {
  //console.log("desktopMode = " + props.desktopMode);

  function imageThumbnails() {
    if (props.images == null) {
      return null;
    }
    return props.images.map((img, i) => (
      // Without the `key`, React will fire a key warning
      <div
        key={"dot_" + i}
        className={props.currentIdx === i ? "dot-thumb attiva" : "dot-thumb"}
        idx={i}
        onClick={(e) => props.clickHandler(e, i)}
      >
        &nbsp;
      </div>
    ));
  }
  function videoThumbnails() {
    if (props.videos == null) {
      return null;
    }
    return props.videos.map((vid, i) => (
      // Without the `key`, React will fire a key warning
      <div
        key={"dot_" + (i+props.images.length)}
        className={props.currentIdx === (i+props.images.length) ? "dot-thumb attiva" : "dot-thumb"}
        idx={props.images.length + i}
        onClick={(e) => props.clickHandler(e, (props.images.length + i))}
      >
        &nbsp;
      </div>
    ));
  }

  return (
    <div className="riga-thumbnails-dot">
      <div className="contenitore-thumbnails-dot">
      {imageThumbnails()}
      {videoThumbnails()}
      </div>
    </div>
  );
}

export default SlideThumbnailRow;